'use client'

import Carousel from '@components/common/Carousel/Carousel'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import { theme } from '@ui/style'
import { JournalistResponseVo } from '@schemas/non-auth'
import AuthorSlideItem from './AuthorSlideItem'

export interface AuthorSlideProps {
	journalist?: Array<JournalistResponseVo>
}
const AuthorSlide = ({ journalist }: AuthorSlideProps) => {
	return (
		<Box
			className="print-hide"
			mx={{ xs: pxToRem(-20), md: 'auto' }}
			width={{ md: pxToRem(616), lg: pxToRem(536), xl: pxToRem(704) }}
			sx={{
				'.swiper-button-next': {
					right: pxToRem(-52),
				},
				'.swiper-button-prev': {
					left: pxToRem(-52),
				},
				'& .swiper:not(.swiper-initialized)': {
					[theme.breakpoints.up('md')]: {
						'& .swiper-wrapper': {
							'&>*:not(:first-child)': {
								marginLeft: theme.pxToRem(16),
							},
						},
						'& .swiper-slide': {
							width: `calc((100% - ${theme.pxToRem(16)}) / 2)`,
						},
					},
				},
			}}
		>
			<Carousel
				slidesPerView={1}
				navigation
				pagination
				navSize="md"
				navStroked
				centerInsufficientSlides
				breakpoints={{
					768: {
						slidesPerView: 2,
						spaceBetween: 16,
						slidesPerGroup: 2,
					},
				}}
			>
				{journalist?.map((item) => (
					<Box px={{ xs: pxToRem(20), md: 0 }} key={`journalist-${item.journalistIdx}`}>
						<AuthorSlideItem
							name={item.journalistName ?? ''}
							position={item.journalistPosition ?? ''}
							src={item.journalistProfileImgUrl ?? ''}
							email={item.email ?? ''}
							isSubscribed={item.isSubscribe ?? false}
							idx={item.journalistIdx?.toString()}
						/>
					</Box>
				))}
			</Carousel>
		</Box>
	)
}

export default AuthorSlide
